<div class="dialog-header">
  <div class="dialog-icon-wrapper">
    <div class="dialog-icon new">
      <i class="fa-solid fa-plus"></i>
    </div>
    <div>
      <h2 class="dialog-title">{{ data.id !== -1 ? 'Edit Campaign' : 'New Campaign' }}</h2>
      <p class="dialog-subtitle">Fill in the campaign details</p>
    </div>
  </div>
  <button class="dialog-close" (click)="onCancel()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<mat-dialog-content class="dialog-body">
  <form [formGroup]="campaignForm" class="dialog-form-grid">
    <!-- Commercial Office -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Commercial Office <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="commercialOffice" placeholder="Select office" (valueChange)="onChangeCommercialOffice($event)" [compareWith]="comparatorService.compareById">
          @for( office of commercialOffices; track office ) {
            <mat-option [value]="office">{{ office | objectdesc}}</mat-option>
          }
        </mat-select>
        @if( campaignForm.get('commercialOffice')?.hasError('required') ) {
          <mat-error>Commercial office is required</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Agency -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Agency <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <mat-select formControlName="agency" placeholder="Select agency" (valueChange)="onChangeAgency($event)" [compareWith]="comparatorService.compareById">
          @for( agency of agencies; track agency ) {
            <mat-option [value]="agency">{{ agency | objectdesc}}</mat-option>
          }
        </mat-select>
        @if( campaignForm.get('agency')?.hasError('required') ) {
          <mat-error>Agency is required</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Brand/Advertiser -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Brand/Advertiser <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input
          type="text"
          matInput
          formControlName="brandAdvertiser"
          placeholder="Type to search brand"
          [matAutocomplete]="acBrand">
        <mat-autocomplete #acBrand="matAutocomplete">
          @for( brand of (filteredBrands | async); track brand ) {
            <mat-option [value]="brand">{{ brand }}</mat-option>
          }
        </mat-autocomplete>
        @if( campaignForm.get('brandAdvertiser')?.hasError('required') ) {
          <mat-error>Brand/Advertiser is required</mat-error>
        }
        @if( campaignForm.get('brandAdvertiser')?.hasError('invalidcharacters') ) {
          <mat-error>Brand/Advertiser has invalid characters</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Campaign Title -->
    <div class="dialog-field-group">
      <mat-label class="mat-form-field-label">Campaign Title <span class="req">*</span></mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="campaignTitle" placeholder="Enter campaign title">
        @if( campaignForm.get('campaignTitle')?.hasError('required') ) {
          <mat-error>Campaign title is required</mat-error>
        }
        @if( campaignForm.get('campaignTitle')?.hasError('invalidcharacters') ) {
          <mat-error>Campaign title has invalid characters</mat-error>
        }
      </mat-form-field>
    </div>

    <!-- Target Url -->
    <div class="dialog-field-group dialog-form-grid-full">
      <mat-label class="mat-form-field-label">Target URL</mat-label>
      <mat-form-field appearance="outline">
        <input matInput formControlName="targetUrl" placeholder="Enter target URL">
      </mat-form-field>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="dialog-footer">
  <button class="btn-ghost" (click)="onCancel()">Cancel</button>
  <button class="btn-blue" (click)="onSubmit()" [disabled]="!campaignForm.valid">
    {{ data ? 'Update Campaign' : 'Create Campaign' }}
  </button>
</mat-dialog-actions>
